export default {
  methods: {
    render_chart6(data) {
      let option = {
          // title: {
          //     text: '按材质划分',
          //     top: 10,
          //     left: 10
          // },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  }
              }
          },
          grid: {
            left: 20,
            bottom: 30,
            right: 20
          },
          xAxis: [
              {
                  type: 'category',
                  data: data.map(v=>v.taskName),
                  axisPointer: {
                      type: 'shadow',
                      label: {
                        fontFamily: 'PingFangSC',
                      } 
                  },
                  axisTick: { show: false },
                  axisLabel: {
                    color: 'rgb(255,255,255,.6)',
                    fontFamily: 'PingFangSC',
                  },
                  axisLine: {
                    lineStyle: {
                      color: 'rgba(255,255,255,.15)'
                    }
                  }
              }
          ],
          yAxis: [
              {
                  type: 'value',
                  show: false,
                  axisLabel: {
                    color: 'rgb(135,139,160)'
                  },
                  axisTick: { show: false },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2'
                    }
                  },
                  splitLine: { show: false },
                  minInterval: 1
              },
              {
                  type: 'value',
                  name: '单位：个',
                  axisLine: { show: false },
                  nameTextStyle: {
                    color: 'rgb(255,255,255,.6)',
                    fontFamily: 'PingFangSC',
                    height: 40,
                    width: 80,
                    lineHeight: 40,
                    align: 'right',
                    rich: {}
                  }
              }
          ],
          series: [
              {
                  name: '',
                  type: 'line',
                  data: data.map(v=>v.num),
                  // itemStyle: {
                  //   color: 'rgb(11,183,142)'
                  // },
                  itemStyle: {
                    color: {
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        { offset: 0, color: '#5AC9E1' },
                        { offset: 1, color: '#11B598' }]
                    },
                    barBorderRadius: [5,5,0,0]
                  },
                  label: {
                    show: true,
                    formatter: param => {
                      return param.data + '个'
                    },
                    color: '#FFFFFF',
                    fontFamily: 'PingFangSC',
                  },
                  symbolSize: 10,
                  lineStyle: {
                    type: 'solid'
                  }
              }
          ]
      };
      let $instance = this.$echarts.init(this.$refs['chart6']);
      $instance.setOption(option);

      $instance.on('click', params => {
        let taskId = data[params.dataIndex].taskId
        this.$router.push({
          path: '/newProduct/newproduct-process',
          query: {
            startTime: this.startTime,
            endTime: this.endTime,
            taskIds: taskId
          }
        })
        setTimeout(_=>{
          this.$bus.$emit('lineChartClicked', {
            name: params.name,
            type: 'spu'
          });
        },800)
    });
    }
  }
}